// The one way into the New Enquiry form, shared by every "New Enquiry" button and menu item.
// AddNewEnquiry permission: 0 = not allowed, 1 or 4 = any branch, 5 = the user's own branch only.

export function addEnquiryLevel(store) {
  const permissions = store.getters['auth/getUserPermissions'] || []
  const permission = permissions.find(a => a.permission && a.permission.permissionCode === 'AddNewEnquiry')
  return permission ? permission.permissionLevel : null
}

export function canAddEnquiry(level) {
  return level === 1 || level === 4 || level === 5
}

/** Opens the form, with the customer already chosen when one is given ({customerId, custName}). */
export function openNewEnquiry(vm, customer) {
  const level = addEnquiryLevel(vm.$store)
  if (!canAddEnquiry(level)) {
    if (level === 0) {
      vm.$toast.add({ severity: 'error', summary: 'Not allowed', detail: 'You are not allowed to create a new record', life: 5000 })
    }
    return false
  }
  const query = customer && customer.customerId
    ? { customerId: String(customer.customerId), custName: customer.custName || '' }
    : {}
  vm.$router.push({ name: 'newEnquiry', query })
  return true
}
